<ap-header [menuClass]="'ap-menu-desktop'">
</ap-header>
<div class="ap-empty-spinner" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>
